//@ts-ignore
import socketio from "socket.io-client"
let socket: any = null
if (JSON.parse(process.env.REACT_APP_USE_SOCKETS || "").on) {
    socket = socketio.connect(process.env.REACT_APP_SOCKET_URL)
}
setTimeout(() => {
    if (socket && !socket.connected) {
        socket.close()
        //console.log("canceled socket connection")
    }
}, 5000)
// //console.log("socket => ", socket)
export default socket